(($, Drupal) => {
  Drupal.behaviors.corporateGridView = {
    attach: function attch(context) {
      $('.js-corporate-entity-slider', context).once('slider').each((index, element) => {
        if (window.matchMedia('(max-width: 1024px)').matches) {
          // remove this text element on mobile if it exists. Slick will make an empty space in the
          // slider for it if it exists.
          const mainTextColumnRemove = $('.corporate-entity-grid-view .main-text__column');

          if (mainTextColumnRemove.length) {
            mainTextColumnRemove.remove();
          }

          // slick
          $(element).slick({
            arrows: false,
            dots: true,
            autoplay: true,
            draggable: true,
            speed: 1000,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
          });
        }
      });
    },
  };
})(jQuery, Drupal);
